import {
  IThreeLayerID,
  IR2Paths,
  IEntityBase,
  IMetadata
} from '../types/base';
import { IOwnership } from '../types/ownership';
import { IVisibilityChild } from '../types/visibility';
import { IFork } from '../types/fork';
import { IVersionRelation } from '../types/version';
import { ITriggerGroup, triggerGroupUtils } from './ITriggerGroup';
import { IActionGroup, actionGroupUtils } from './IActionGroup';
import { ulid } from 'ulid';
import { createTriggerActionUtils } from '../utils/triggerActionUtils';

/**
 * 触发器-动作配对接口
 * 对应SQL表：project_trigger_action
 * 对应Go结构：ProjectTriggerAction
 *
 * 此接口表示一个触发器和动作的组合配对。
 * 它通过 triggerGroupUuid/triggerGroupUlid 和 actionGroupUuid/actionGroupUlid 字段关联特定的 TriggerGroup 和 ActionGroup。
 * 多个 TriggerAction 可以组织在同一个 TriggerActionGroup 中。
 */
export interface ITriggerAction extends
  IThreeLayerID,
  IEntityBase,
  IR2Paths,
  IOwnership,
  IVisibilityChild,
  IFork,
  IVersionRelation,
  IMetadata
{
  triggerGroupUuid: string;           // 关联的trigger_group的UUID（数据库生成）
  triggerGroupUlid: string;           // 关联的trigger_group的ULID（Web端生成）- 必填
  actionGroupUuid: string;            // 关联的action_group的UUID（数据库生成）
  actionGroupUlid: string;            // 关联的action_group的ULID（Web端生成）- 必填

  // 运行时填充字段 - Web端必须初始化
  triggerGroup: ITriggerGroup;        // 完整的 TriggerGroup 对象 - 必填
  actionGroup: IActionGroup;          // 完整的 ActionGroup 对象 - 必填
}

// === 类型常量 ===
export const triggerActionType = 'triggerAction'

// === 创建默认 TriggerAction ===
export function createDefaultTriggerAction(): ITriggerAction {
  const triggerGroup = triggerGroupUtils.createDefaultData()
  const actionGroup = actionGroupUtils.createDefaultData()
  const triggerActionUlid = ulid()
  return {
    ulid: triggerActionUlid,
    uuid: '',
    triggerGroupUuid: triggerGroup.uuid,
    triggerGroupUlid: triggerGroup.ulid,
    actionGroupUuid: actionGroup.uuid,
    actionGroupUlid: actionGroup.ulid,
    triggerGroup,
    actionGroup,
    createdAt: Date.now(),
    updatedAt: Date.now()
  } as ITriggerAction
}

// === TriggerAction Utils ===
export const triggerActionUtils = createTriggerActionUtils(
  triggerActionType,
  createDefaultTriggerAction
)
